import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ClockComponent } from './clock/clock.component';
import { TimepickerDialogComponent } from './timepicker-dialog/timepicker-dialog.component';
import { TimepickerDirective } from './timepicker.directive';

const depComponents = [MatDialogModule, MatToolbarModule, MatButtonModule, MatIconModule, MatInputModule];

@NgModule({
  declarations: [ClockComponent, TimepickerDialogComponent, TimepickerDirective],
  imports: [CommonModule, ...depComponents],
  exports: [TimepickerDirective],
})
export class TimepickerModule {}
